import type { ToolbarButton } from '../../models';

/** Filters first and last separators if there is nothing behind/ahead of them and
 * if there are two or more next to each other, it only leaves one
 * @example
 * | A | B || C | D | -> A | B | C | D
 */
export const filterExcessiveToolbarSeparators = (itemsConfig: ToolbarButton[]) => {
  const firstSeparatorIndex = itemsConfig.findIndex(item => item.getId() !== 'separator');
  const startIndex = firstSeparatorIndex === -1 ? 0 : firstSeparatorIndex;

  const endIndex = itemsConfig
    .slice(startIndex)
    .reverse()
    .findIndex(item => item.getId() !== 'separator');

  const trimmedItems = itemsConfig.slice(startIndex, itemsConfig.length - endIndex);

  return trimmedItems.filter((config, index, allConfigs) => {
    return (
      config.getId() !== 'separator' ||
      (index !== 0 && allConfigs[index - 1]?.getId() !== 'separator')
    );
  });
};
